<template>
  <div>

    <form-field-input
      label="Lead"
      :value="record.property.line_1"
      :disabled="true"
    ></form-field-input>

    <form-field-select
      label="Contact"
      v-model="form.contact_id"
      :validation-errors="validationErrors.contact_id"
    >
      <option :value="null">Select a Contact</option>
      <option
        v-for="contact in contacts"
        :key="contact.id"
        :value="contact.id"
      >
        <template v-if="contact.id === record.primary_contact_id">{{contact.full_name}} (Primary)</template>
        <template v-else>{{contact.full_name}}</template>
      </option>
    </form-field-select>

    <form-field-select
      label="Follow Up Template"
      v-model="form.FUS_template_id"
      :validation-errors="validationErrors.FUS_template_id"
      @change.native="updateForm"
      show-label="description"
      :show-value="selectedTemplateDescription"
    >
      <option :value="null">Select a template</option>
      <option
        v-for="followUpTemplate in allFollowUpTemplates"
        :key="followUpTemplate.id"
        :value="followUpTemplate.id"
        :disabled="!followUpTemplate.step_count"
      >
        {{ templateLabel(followUpTemplate) }}
      </option>
    </form-field-select>

    <form-field-select-status
      label="Change Status"
      help-text="Changing status is not required"
      v-show="form.record_id"
      v-model="form.default_status_id"
      :validation-errors="validationErrors.default_status_id"
      include-no-status
    ></form-field-select-status>

    <form-field-select-user-emails
      label="Email From"
      v-model="form.user_id"
      :validation-errors="validationErrors.user_id"
    ></form-field-select-user-emails>

    <form-field-input
      label="Email From Name"
      v-model="form.from_name"
      :validation-errors="validationErrors.from_name"
    ></form-field-input>

    <form-field-select-integration-phone-number
      label="From Number"
      v-model="form.integration_phone_number_id"
      :validation-errors="validationErrors.integration_phone_number_id"
    ></form-field-select-integration-phone-number>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";
  import {ENUMS} from "../services/enums";

  export default {
    name: "RecordFollowUpSequenceForm",
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
        isAtLimit: false,
        defaultForm: {
          record_id: this.$store.state.activeRecord.record.id,
          contact_id: this.$store.state.activeRecord.record.primary_contact_id,
          user_id: null,
          from_name: '',
          FUS_template_id: null,
          integration_phone_number_id: null,
        },
      }
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
    },
    computed: {
      allFollowUpTemplates() {
        return this.$store.getters.fusTemplates;
      },
      record() {
        return this.$store.state.activeRecord.record;
      },
      contacts() {
        return this.$store.state.activeRecord.contacts;
      },
      primaryContact() {
        const contact = this.contacts.find(contact => contact.id === this.record.primary_contact_id);
        return contact ? contact.full_name : null;
      },
      selectedTemplateDescription() {
        if(this.form.FUS_template_id) {
          const template = this.allFollowUpTemplates.find(f => f.id === this.form.FUS_template_id);

          return template.description ? template.description : null;
        }

        return null;
      },
    },
    methods: {
      templateLabel(template) {
        if(template.step_count) {
          return template.label
        } else {
          return template.label + ' (needs steps before using)'
        }
      },
      updateForm() {
        const template = this.$store.getters.fusTemplates.find(f => f.id === this.form.FUS_template_id);
        const integrationNumber = this.$store.state.market.integrationPhoneNumbers.find(n => n.id === template.integration_phone_number_id);
        const campaignId = this.record.campaign_id;
        const campaign = this.$store.getters.campaigns.find(c => c.id === campaignId)

        // Set the email from and from name from template
        this.form.user_id = template.user_id;
        this.form.from_name = template.from_name;

        // Make sure the template record count isn't exceeded
        this.isAtLimit = template.record_count >= this.$store.getters.maxRecordsPerFusTemplate;

        // Reset the value before setting it because this field can be nullable
        this.form.integration_phone_number_id = null;
        // Set the integration number
        if(template.use_records_campaign_number && campaign && campaign.integrationPhoneNumber) {
          this.form.integration_phone_number_id = campaign.integrationPhoneNumber.id;
        } else if(integrationNumber) {
          this.form.integration_phone_number_id = integrationNumber.id
        }

        // Set default status
        this.form.default_status_id = template.default_status_id
      },
      create() {
        if(this.isAtLimit) {
          this.$buefy.toast.open({
            message: 'This follow up is at it\'s record count limit.',
            type: 'is-danger'
          });
        } else {
          return this.$api.followUp.create(this.form).then(res => {
            this.$buefy.toast.open({
              message: 'Follow Up Sequence was created',
              type: 'is-success'
            });

            return res;
          });
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
